import type { HistoryRequestRow } from '../../models/vacationHistoryReport.types';
import type { HistoryEventKind } from '../../models/vacationHistoryReport.types';
import { HistoryResultCard } from './components';
import { HISTORY_CARD_LABELS } from './vacationHistoryResultsCards.definitions';

interface VacationHistoryResultsCardsProps {
    rows: HistoryRequestRow[];
    isLoading?: boolean;
    onSelectRequest?: (row: HistoryRequestRow) => void;
    highlightedKind?: string;
    kind?: HistoryEventKind;
    periodFilterKey?: string | null;
}

export function VacationHistoryResultsCards({
    rows,
    isLoading,
    onSelectRequest,
    highlightedKind,
    kind = 'requested',
    periodFilterKey = null,
}: VacationHistoryResultsCardsProps) {
    if (isLoading) {
        return (
            <div className="rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
                {HISTORY_CARD_LABELS.loading}
            </div>
        );
    }

    if (rows.length === 0) {
        return (
            <div className="rounded-lg border border-dashed border-gray-300 bg-white p-10 text-center">
                <p className="text-sm text-gray-600">{HISTORY_CARD_LABELS.empty}</p>
            </div>
        );
    }

    return (
        <div className="grid gap-4 grid-cols-1">
            {rows.map((row) => (
                <HistoryResultCard
                    key={row.isManual ? `manual-${row.collaborator.id}-${row.segments[0]?.startDate}-${row.manualIndex}` : row.requestId}
                    row={row}
                    kind={kind}
                    periodFilterKey={periodFilterKey}
                    highlightedKind={highlightedKind}
                    onSelectRequest={onSelectRequest}
                />
            ))}
        </div>
    );
}

export default VacationHistoryResultsCards;
